<template>
    <div>
        <HomeTile
            ref="homeTile"
            :title="currentSite.facility"
            subtitle="Informations du site"
            icon="industry"
            route="Site"
            @enableActionButtons="enableActionButtons"
        >
        </HomeTile>
        <TreeStructure
            ref="treeStructure"
            @enableActionButtons="enableActionButtons"
        ></TreeStructure>
        <!-- TODO: rework synoptic view with tree structure and synoptic view -->
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import HomeTile from '@/components/page/Home/HomeTile.vue';
import TreeStructure from '@/components/page/Synoptic/TreeStructure.vue';
    export default {
        name: 'Synoptic',
        components: {
            HomeTile,
            TreeStructure
        },
        computed:{
            ...mapGetters(['currentSite'])
        },
        methods:{
            enableActionButtons(props){
                this.$emit('enableActionButtons', props);
            },
            refreshData(){
                this.$refs.treeStructure.reloadData()
            }
        }
    }
</script>

<style lang="scss" scoped>

</style>


// WEBPACK FOOTER //
// src/components/page/Synoptic/Index.vue